import _s from 'underscore.string'
import isString from 'strings/isString'

export default (value) => isString(value) && _s.include(value.toLowerCase(), ' or ')
